module.exports = __webpack_public_path__ + "static/monikawork8-5dc3e68c382abb9a6ff278233b84954c.jpg";